import React from "react";
import { Link } from "react-router-dom";
import { Container, PageHeader } from "@/components/common";
import { Footprints, ArrowRight } from "lucide-react";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-|-$/g, "");

const STEPS = [
  { name: "Grapevine", id: "sSo3qTVhzBY", dances: ["Electric Slide", "Red Hot Salsa", "Mamma Maria"] },
  { name: "Shuffle Step", id: "4ptEWESJ_s8", dances: ["16 Step", "County Line Cha Cha", "Hooked On Country"] },
  { name: "Coaster Step", id: "w7kFINlJovs", dances: ["Halfway Hustle", "Country Walkin'"] },
  { name: "Side Shuffle", id: "1vRW2R31W1Y", dances: [] },
  { name: "Step Pivot Turn", id: "40zo1e2UVYU", dances: ["16 Step", "Hooked On Country", "Halfway Hustle"] },
  { name: "Sailor Step", id: "jaAPTottbxo", dances: [] },
  { name: "Weave", id: "cJeIjZmKnLU", dances: ["The Lemon Tree", "Lucky Lips"] },
  { name: "Kick Ball Change", id: "gENaB7j3XwY", dances: ["Red Hot Salsa"] },
  { name: "Point", id: "VfoGfzlnn-s", dances: ["Halfway Hustle", "Stomping It Out", "The Lemon Tree"] },
  { name: "Jazz Box", id: "PnEgYDrwZR4", dances: ["Country Walkin'", "Cowboy Strut"] },
  { name: "Charleston Step", id: "ruUH5NRg8o4", dances: ["Cowboy Charleston", "Mamma Maria"] },
  { name: "Rhumba Box", id: "4QlNB-XCJqY", dances: ["Lucky Lips"] },
  { name: "Rock Step", id: "qm7C3vQP5pU", dances: ["County Line Cha Cha", "Red Hot Salsa", "The Lemon Tree"] },
  { name: "Syncopated Cross Step", id: "yUaj-1fPYnU", dances: ["Hooked On Country"] },
  { name: "Monterey Turn", id: "y4fzrOUpLUI", dances: [] },
];

export default function BasicSteps() {
  return (
    <div>
      <PageHeader eyebrow="Learn the moves" title="Basic steps"
        subtitle="Short tutorial videos for the building-block steps behind most line dances. Great before your first class or for a little practice at home — under each video you'll find dances that use that step." />
      <Container className="py-10">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {STEPS.map((s) => (
            <div key={s.id} className="flex flex-col overflow-hidden rounded-2xl border border-border bg-card" data-testid={`basic-step-${slug(s.name)}`}>
              <div className="aspect-video w-full bg-black">
                <iframe className="h-full w-full" loading="lazy" title={`How to ${s.name}`}
                  src={`https://www.youtube-nocookie.com/embed/${s.id}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="flex items-center gap-2 font-display text-lg font-bold text-[#2D1E18]"><Footprints size={18} className="text-[#B04B26]" /> {s.name}</h3>
                {s.dances.length > 0 && (
                  <div className="mt-3">
                    <p className="text-xs font-bold uppercase tracking-widest text-[#6E5B51]">Featured in</p>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {s.dances.map((d) => (
                        <Link key={d} to={`/dances/${slug(d)}`} data-testid={`basic-step-dance-${slug(d)}`}
                          className="rounded-full bg-secondary px-3 py-1 text-xs font-semibold text-[#5C4A42] hover:bg-[#FBEBE4] hover:text-[#B04B26]">{d}</Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-10 rounded-2xl bg-[#2D1E18] p-6 text-white sm:flex sm:items-center sm:justify-between">
          <div>
            <h3 className="font-display text-xl font-bold">Ready to try them for real?</h3>
            <p className="mt-1 text-sm text-[#EDE4DA]">Come along to a beginner class — no partner, no booking, just turn up.</p>
          </div>
          <Link to="/classes" data-testid="basic-steps-find-class" className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#C85A32] px-5 py-3 font-bold text-white hover:bg-[#B04B26] sm:mt-0">Find a class <ArrowRight size={16} /></Link>
        </div>
      </Container>
    </div>
  );
}
